module.exports = __webpack_public_path__ + "img/calendar2-minus.9b76515d.svg";